import { Component } from '@angular/core';
import { JobseekerService } from '../shared/services/jobseeker.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import {
  JobseekerModerationAttributeEnum,
  JobseekerModeratienViewModel,
} from '../shared/models/jobseeker-moderation.model';

@Component({
  selector: 'app-moderation-jobseeker',
  templateUrl: './moderation-jobseeker.component.html',
  styleUrls: ['./moderation-jobseeker.component.less'],
  standalone: false,
})
export class ModerationJobseekerComponent {
  public jobseeker: JobseekerModeratienViewModel;
  public jobseekerId!: number;
  public contactResetMap: { [key: number]: string } = {};
  public workExperienceResetMap: { [key: number]: string } = {};
  public languageResetMap: { [key: number]: string } = {};
  public documentResetMap: { [key: number]: string } = {};
  public educationResetMap: { [key: number]: string } = {};
  public skillResetMap: { [key: number]: string } = {};

  constructor(
    private jobseekerService: JobseekerService,
    private activatedRoute: ActivatedRoute
  ) {}

  setValue(rejectedLabel) {
    this.contactResetMap[rejectedLabel.key] = rejectedLabel.value;
  }
  setAttachmentDictionary(event) {
    this.documentResetMap[event.key] = event.value;
  }
  setLanguageDictionary(event) {
    this.languageResetMap[event.key] = event.value;
  }
  setEducationDictionary(event) {
    this.educationResetMap[event.key] = event.value;
  }
  setWorkExperienceDictionary(event) {
    this.workExperienceResetMap[event.key] = event.value;
  }
  setSkillDictionary(event) {
    this.skillResetMap[event.key] = event.value;
  }

  getJobseekerData(jobseekerId) {
    this.jobseekerService
      .getModerationJobseeker(jobseekerId)
      .subscribe((payload: any) => {
        this.jobseeker = payload.data;
      });
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.jobseekerId = +params.get('jobseekerId');
      this.getJobseekerData(this.jobseekerId);
    });
  }
}
